// src/components/VstupniInformaceForm.jsx
import React, { useEffect, useState } from "react";
import { useFormData } from "../context/FormDataContext";
import { useAutoSaveZakazka } from "../hooks/useAutoSaveZakazka";
import { getToken } from "../auth/authClient";


// === AUTO FIX: sanitize + name split for Vyjezd -> Vstupni informace ===
function cleanText(v) {
  return String(v || "")
    .replace(/[^0-9A-Za-zÀ-ž .,:;\/\-]/g, " ")  // pryč § a podobné
    .replace(/\s+/g, " ")
    .trim();
}
function splitFullName(full) {
  const t = String(full || "").replace(/\s+/g, " ").trim();
  if (!t) return { jmeno: "", prijmeni: "" };
  const parts = t.split(" ").filter(Boolean);
  if (parts.length === 1) return { jmeno: parts[0], prijmeni: "" };
  return { jmeno: parts[0], prijmeni: parts.slice(1).join(" ") };
}

function splitPlaceAddress(v) {
  const t = String(v || "").replace(/\s+/g, " ").trim();
  if (!t) return { place: "", address: "" };

  // "Město, ulice 123" -> place="Město", address="ulice 123"
  if (t.includes(",")) {
    const parts = t.split(",").map(x => x.trim()).filter(Boolean);
    const place = parts.shift() || "";
    const address = parts.join(", ").trim();
    return { place, address: address || t };
  }

  // "Frymburk 25" / "Český Krumlov Pod Skalkou 525" -> place=část před prvním číslem
  const m = t.match(/^(.+?)\s+(\d.*)$/);
  if (m) {
    const place = (m[1] || "").trim();
    return { place, address: t };
  }

  // fallback: když není číslo ani čárka, ber vše jako "místo"
  return { place: t, address: t };
}
// === /AUTO FIX ===


const inputStyle = {
  width: "100%",
  padding: "10px 12px",
  borderRadius: 10,
  border: "1px solid #444",
  outline: "none",
};

const labelStyle = { fontSize: 13, fontWeight: 800, marginBottom: 6 };

const isEmpty = (v) => v == null || String(v).trim() === "";

  // ✅ NORMALIZACE hodnot (ochrana proti "1 znak" když někde přijde array znaků)
  function normInputValue(x) {
    if (Array.isArray(x)) {
      const arr = x
        .filter(v => v !== null && v !== undefined)
        .map(v => String(v).trim())
        .filter(Boolean);
      if (!arr.length) return "";
      const allOneChar = arr.every(v => v.length === 1);
      const joined = allOneChar ? arr.join("") : arr.join(" ");
      return joined.replace(/\s+/g, " ").trim();
    }
    return String(x || "")
      .replace(/,/g, "")      // "g,r,s" -> "grs"
      .replace(/\s+/g, " ")
      .trim();
  }

export default function VstupniInformaceForm() {
  
  const ctx = useFormData();
  // === AUTO: Výjezd -> Vstupní informace (tlačítko) ===
  function applyVyjezdAutoToVstupni() {
    try {
      const setFormData = (ctx && (ctx.setFormData || ctx._setFormData)) || null;
      const formData = (ctx && ctx.formData) || {};
      const v = formData?.vyjezdAuto;
      if (!v) {
        alert("⚠️ Není vybraný výjezd. Ve Výjezdech klikni 'Použít do Vstupních informací'.");
        return;
      }
      if (typeof setFormData !== "function") {
        alert("⚠️ Nelze uložit (chybí setFormData v kontextu).");
        return;
      }

      const ok = window.confirm(
        "Vyplnit Vstupní informace z vybraného výjezdu?\n\n" +
        "Doplní: datum/čas úmrtí, místo/adresu úmrtí + poznámku.\n" +
        "Pokud už máš něco ručně, zkontroluj po vyplnění."
      );
      if (!ok) return;

      setFormData((prev) => {
        const vi = (prev && prev.vstupniInformace && typeof prev.vstupniInformace === "object") ? prev.vstupniInformace : {};
        const addNote = [
          `Výjezd: ${String(v.datum || "")} ${String(v.casOd || "")}${v.casDo ? "–" + String(v.casDo) : ""}`,
          `Auto: ${String(v.autoSpz || "")}${v.km ? " (" + String(v.km) + " km)" : ""}`,
          `Trasa: ${String(v.odkud || "")} → ${String(v.kam || "")}`,
          (v.poznamka ? `Pozn.: ${String(v.poznamka)}` : ""),
        ].filter(Boolean).join(" | ");

        return {
          ...prev,
          vstupniInformace: {
            ...vi,
              ...(() => {
                const full =
                  (v.jmenoZesnulehoCele || v.zesnulyJmenoCele || v.jmenoZesnuleho || v.zesnulyJmeno || "").toString();
                const sp = splitFullName(full);
                  const preferNon1 = (candidate, source, fallback) => {
                    const c = String(candidate || "").trim();
                    const src = String(source || "").trim();
                    if (c.length <= 1 && src.length > 1) return String(fallback || "").trim();
                    return c;
                  };

                return {
                  ...(sp.jmeno ? { jmenoZesnuleho: (String(vi.jmenoZesnuleho||"").trim().length<=1 ? preferNon1(sp.jmeno, full, vi.jmenoZesnuleho) : vi.jmenoZesnuleho) } : {}),
                  ...(sp.prijmeni ? { prijmeniZesnuleho: (String(vi.prijmeniZesnuleho||"").trim().length<=1 ? preferNon1(sp.prijmeni, full, vi.prijmeniZesnuleho) : vi.prijmeniZesnuleho) } : {}),
                };
              })(),
                          // === AUTO FIX: vyplnit z výjezdu správnými poli ===
              ...( (v.datumUmrti || v.datum_umrti || v.datumUmrtiText || v.datumUmrtiRaw) ? { datumUmrti: vi.datumUmrti || String(v.datumUmrti || v.datum_umrti || v.datumUmrtiText || v.datumUmrtiRaw) } : {}),
              ...( (v.casUmrti || v.cas_umrti) ? { casUmrti: vi.casUmrti || String(v.casUmrti || v.cas_umrti) } : {}),
              ...( v.mistoUmrti ? (() => { const pa = splitPlaceAddress(v.mistoUmrti); return { mistoUmrti: cleanText((String(vi.mistoUmrti||"").trim().length<=1) ? preferNon1(pa.place, v.mistoUmrti, vi.mistoUmrti) : vi.mistoUmrti) }; })() : {}),
              ...( v.mistoUmrti ? (() => { const pa = splitPlaceAddress(v.mistoUmrti); return { adresaUmrti: cleanText((String(vi.adresaUmrti||"").trim().length<=1) ? preferNon1(pa.address, v.mistoUmrti, vi.adresaUmrti) : vi.adresaUmrti) }; })() : {}),
              // === /AUTO FIX ===

            poznamka: (String(vi.poznamka || "").trim()
              ? (String(vi.poznamka).trim() + "\n" + addNote)
              : addNote),
          },
        };
      });

      alert("✅ Vstupní informace doplněny z výjezdu.");
    } catch (e) {
      console.error("applyVyjezdAutoToVstupni error:", e);
      alert("❌ Nepodařilo se doplnit Vstupní informace z výjezdu.");
    }
  }
  // === /AUTO ===

const { formData, setFormData, currentOrderId, setIsEditingExisting } = useFormData();
// ✅ autosave musí být uvnitř komponenty
  useAutoSaveZakazka(false, 900);

  // ✅ API base (prod bere z .env = https://api.pspohrebka.cz)
  const API_BASE = String(import.meta?.env?.VITE_API_BASE_URL || "").replace(/\/+$/, "");


  const v = formData?.vstupniInformace || {};
  const vyj = formData?.vyjezdy || {};


    // === AUTO-FIX ONECHAR (VyjezdAuto -> VstupniInformace) ===
    // Když se někde rozbije jméno/příjmení/místo na 1 znak, oprav to z vyjezdAuto/vyjezdy.
    useEffect(() => {
      // AUTO-FIX ONECHAR dočasně vypnuto:
      // způsoboval přepis otevřené zakázky starými daty při přepínání mezi ID.
    }, []);
    // === /AUTO-FIX ONECHAR ===
    // ✅ 1 znak bereme jako „prázdné“ (vzniká z bugů typu 'F', 'L')
    const isBlankish = (x) => String(x ?? "").replace(/\s+/g," ").trim().length <= 1;



  // ✅ AUTO-SYNC: VYJEZDY -> VSTUPNÍ INFORMACE (doplní jen prázdná pole)
  useEffect(() => {
    // AUTO-SYNC VYJEZDY -> VSTUPNÍ INFORMACE dočasně vypnuto:
    // způsoboval přepis otevřené zakázky při přepínání mezi ID.
  }, [currentOrderId]);

  // ✅ AUTO-SYNC: Vstupní informace -> Převoz (doplní jen prázdná pole)
  useEffect(() => {
    // AUTO-SYNC Vstupní informace -> Převoz dočasně vypnuto:
    // způsoboval přepis otevřené zakázky při přepínání mezi ID.
  }, [currentOrderId]);

  const MAP_TO_ZESNULA = {
    rodneCislo: "rodneCislo",
    datumUmrti: "datumUmrti",
    casUmrti: "casUmrti",
    mistoUmrti: "mistoUmrti",
    adresaUmrti: "adresaUmrti",

    // ✅ robustní mapování narození
    datumNarozeni: "datumNarozeni",
    datumNarozeniZesnuleho: "datumNarozeni",

    datumProhlidky: "datumProhlidky",
    casProhlidky: "casProhlidky",
    pitevna: "pitevna",
    lekarJmeno: "lekarJmeno",
    lekarTelefon: "lekarTelefon",
    diagnoza: "diagnoza",
    infekce: "infekce",
    poznamka: "poznamka",
  };

  const setField = (name, value) => {
    value = normInputValue(value);

    setFormData((prev) => {
      const next = { ...prev };
      const vstupPrev = prev?.vstupniInformace || {};
      const zesPrev = prev?.zesnulaOsoba || {};

      const vstupNext = { ...vstupPrev, [name]: value };
      next.vstupniInformace = vstupNext;

      let zesNext = { ...zesPrev };

      if (name === "jmenoZesnuleho") { zesNext.jmeno = value; vstupNext.zesnulyJmeno = value; }
      if (name === "prijmeniZesnuleho") { zesNext.prijmeni = value; vstupNext.zesnulyPrijmeni = value; }

      if (name === "trvaleBydliste") {
        zesNext.trvaleBydliste = value;
        zesNext.adresaTrvalehoBydliste = value;
      }

      if (name === "adresaZesnuleho") {
        vstupNext.trvaleBydliste = value;
        zesNext.trvaleBydliste = value;
        zesNext.adresaTrvalehoBydliste = value;
      }

      const targetKey = MAP_TO_ZESNULA[name];
      if (targetKey) zesNext[targetKey] = value;

      next.zesnulaOsoba = zesNext;
      return next;
    });
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setField(name, value);
  };

  // =========================
  // ✅ ULOŽENÍ DO KNIHY
  // =========================
  const [saveMsg, setSaveMsg] = useState("");
  const [saveErr, setSaveErr] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSaveToKniha = async () => {
    setSaveMsg("");
    setSaveErr("");
    setSaving(true);

    try {
      if (typeof ctx?.saveOrder !== "function") {
        throw new Error("Chybí saveOrder() v kontextu.");
      }

      const out = await ctx.saveOrder();
      const newId = String(
        out?.id ||
        out?.meta?.id ||
        ctx?.currentOrderId ||
        currentOrderId ||
        formData?.id ||
        formData?.orderId ||
        ""
      ).trim();

      try {
        if (typeof setIsEditingExisting === "function" && newId) {
          setIsEditingExisting(true);
        }
      } catch (e) {}

      setSaveMsg(newId ? `Uloženo do knihy: ${newId}` : "Uloženo.");
    } catch (e) {
      setSaveErr(e?.message || "Uložení selhalo.");
    } finally {
      setSaving(false);
    }
  };
  
  // ✅ setPath fallback (aby fungovalo setPath(...) i když ho context neposkytuje)
  const setPath = (pathStr, value) => {
    const p = String(pathStr || "").split(".").filter(Boolean);
    if (!p.length) return;

    setFormData((prev) => {
      const out = { ...(prev || {}) };
      let cur = out;
      for (let i = 0; i < p.length; i++) {
        const k = p[i];
        const last = i === p.length - 1;
        if (last) {
          cur[k] = value;
        } else {
          const next = cur[k];
          cur[k] = next && typeof next === "object" ? { ...next } : {};
          cur = cur[k];
        }
      }
      return out;
    });
  };

/* AUTO_IDENTITA_HELPERS */
  const ident = (formData && formData.identita) ? formData.identita : {};
  const dok = ident?.doklady ?? {};

  const getAnyToken = () => (
    getToken()||
    ""
  );

  const resolveOrderId = () => {
    // zkusíme co nejvíc variant, protože v appce se to mohlo jmenovat různě
    return (
  <>
      (formData && (formData.currentOrderId || formData.orderId || formData.zakazkaId)) ||
      (ctx && (ctx.currentOrderId || ctx.orderId)) ||
      (formData && formData.meta && (formData.meta.orderId || formData.meta.id)) ||
      ""
  </>
    );
  };

  const setAnyPath = (pathStr, value) => {
    if (ctx && typeof ctx.setPath === "function") return ctx.setPath(pathStr, value);
    if (ctx && typeof ctx.updateValue === "function") return ctx.updateValue(pathStr, value);
    if (ctx && typeof ctx.setValue === "function") return ctx.setValue(pathStr, value);

    // fallback: setFormData deep set
    if (ctx && typeof ctx.setFormData === "function") {
      ctx.setFormData((prev) => {
        const parts = String(pathStr || "").split(".").filter(Boolean);
        if (!parts.length) return prev;
        const out = { ...(prev || {}) };
        let cur = out;
        for (let i = 0; i < parts.length; i++) {
          const k = parts[i];
          const last = i === parts.length - 1;
          if (last) cur[k] = value;
          else {
            const next = cur[k];
            cur[k] = next && typeof next === "object" ? { ...next } : {};
            cur = cur[k];
          }
        }
        return out;
      });
    }
  };

  const uploadOne = async (fileObj, kategorie) => {
    const orderId = resolveOrderId();
    if (!orderId) {
      alert("Chybí ID zakázky (orderId). Nejdřív ulož zakázku / vytvoř ID.");
      return null;
    }
    if (!fileObj) return null;

    const fd = new FormData();
    fd.append("orderId", orderId);
    fd.append("kategorie", kategorie);
    fd.append("files", fileObj);

    const token = getAnyToken();
    const r = await fetch(`${API_BASE}/api/foto/upload`, {
      method: "POST",
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      body: fd,
    });

    const data = await r.json().catch(() => null);
    if (!r.ok || !data?.ok) {
      const err = data?.error || `Upload selhal (${r.status})`;
      alert(err);
      return null;
    }
    const saved = (data.saved && data.saved) ? data.saved : null;
    return saved; // {kategorie, file}
  };

  const fileUrl = (saved, fallbackKat) => {
    const orderId = resolveOrderId();
    if (!orderId || !saved?.file) return "";
    const kat = saved.kategorie || fallbackKat || "jine";
    return `/api/foto/file?orderId=${encodeURIComponent(orderId)}&kategorie=${encodeURIComponent(kat)}&file=${encodeURIComponent(saved.file)}`;
  };

  const isCz = () => String(ident?.statniPrislusnost || "ČR").trim().toUpperCase() === "ČR";


  return (

  <>
<div className="vi-page">
        {/* === AUTO: Výjezd -> Vstupní informace === */}
        <div style={{ margin: "10px 0", padding: 12, border: "1px solid #ddd", borderRadius: 12 }}>
          <div style={{ fontWeight: 900, marginBottom: 8 }}>🚑 Výjezd</div>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
            <button
              type="button"
              onClick={applyVyjezdAutoToVstupni}
              style={{ padding: "10px 14px", borderRadius: 10, border: "1px solid #444", cursor: "pointer", fontWeight: 900 }}
              title="Doplní datum/čas/místo úmrtí + poznámku z vybraného výjezdu"
            >
              Vyplnit z výjezdu
            </button>
            <div style={{ fontSize: 12, opacity: 0.8 }}>
              Nejdřív ve Výjezdech klikni „Použít do Vstupních informací“.
            </div>
          </div>
        </div>
        {/* === /AUTO === */}

  <style>{"\n/* VSTUPNI_SKIN */\n.vi-page{max-width:1100px;margin:0 auto;padding:14px 12px 24px;}\n.vi-topbar{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:14px;border-radius:18px;border:1px solid rgba(255,255,255,0.12);background:rgba(255,255,255,0.05);}\n.vi-topbar h2{margin:0;font-size:18px;font-weight:900;letter-spacing:.2px;}\n.vi-chip{display:inline-flex;align-items:center;gap:8px;padding:6px 10px;border-radius:999px;background:rgba(255,255,255,0.08);border:1px solid rgba(255,255,255,0.10);font-size:12px;opacity:.9;}\n.vi-grid{display:grid;gap:12px;margin-top:12px;}\n.vi-card{padding:14px;border-radius:18px;border:1px solid rgba(255,255,255,0.12);background:rgba(0,0,0,0.18);}\n.vi-card h3{margin:0 0 10px 0;font-size:14px;font-weight:900;}\n.vi-sub{font-size:12px;opacity:.75;margin-top:6px;line-height:1.35;}\n.vi-row{display:grid;grid-template-columns:repeat(auto-fit,minmax(260px,1fr));gap:12px;}\n.vi-label{font-size:12px;opacity:.75;margin-bottom:6px;}\n.vi-input,.vi-select,.vi-textarea{width:100%;padding:10px 12px;border-radius:14px;border:1px solid rgba(255,255,255,0.18);background:rgba(255,255,255,0.06);color:inherit;outline:none;}\n.vi-textarea{min-height:88px;resize:vertical;}\n.vi-input:focus,.vi-select:focus,.vi-textarea:focus{border-color:rgba(255,255,255,0.32);background:rgba(255,255,255,0.08);}\n.vi-warn{padding:12px;border-radius:16px;border:1px solid rgba(255,200,0,0.35);background:rgba(255,200,0,0.08);}\n.vi-warn b{font-weight:900;}\n.vi-details{margin-top:12px;border-radius:18px;border:1px solid rgba(255,255,255,0.12);background:rgba(255,255,255,0.04);padding:12px;}\n.vi-details summary{cursor:pointer;font-weight:900;font-size:15px;display:flex;justify-content:space-between;align-items:center;gap:12px;}\n.vi-details summary span:last-child{font-size:12px;opacity:.65;font-weight:700;}\n.vi-hr{height:1px;background:rgba(255,255,255,0.10);border:0;margin:12px 0;}\n"}</style>

    <div style={{ padding: 16, maxWidth: 1000 }}>
      <h2 style={{ fontSize: 22, fontWeight: 900, marginBottom: 8 }}>Vstupní informace (OP + Ohledací list)</h2>
{/* AUTO_IDENTITA_UI */}

      {/* AUTO_IDENTITA_UI (PREHLED) */}
      <details style={{
        marginTop: 14,
        padding: 14,
        borderRadius: 16,
        border: "1px solid rgba(255,255,255,0.14)",
        background: "rgba(255,255,255,0.04)"
      }}>
        <summary style={{
          cursor: "pointer",
          fontWeight: 900,
          fontSize: 16,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12
        }}>
          <span>➕ 🪪 Identita (Doklad / Rodný list / Ohledací list)</span>
          <span style={{ fontSize: 12, opacity: 0.7 }}>rozbalit</span>
        </summary>

        <div style={{ marginTop: 12 }}>
          {/* POZN: použij své existující setPath / formData z komponenty.
              Pokud máš v komponentě: const { formData, setPath } = useFormData();
              tak tohle bude fungovat hned. */}
          
          <div style={{ display: "grid", gap: 12 }}>
            {/* Upozornění (jen info, nic nepovinné) */}
            <div style={{
              padding: 12,
              borderRadius: 14,
              border: "1px solid rgba(255,200,0,0.35)",
              background: "rgba(255,200,0,0.08)"
            }}>
              <div style={{ fontWeight: 900, marginBottom: 6 }}>⚠️ Upozornění</div>
              <div style={{ opacity: 0.9, lineHeight: 1.35 }}>
                Necháme tě pokračovat i bez dokladů. Jen tě upozorníme, co chybí.
              </div>
            </div>

            {/* Základ */}
            <div style={{
              padding: 12,
              borderRadius: 14,
              border: "1px solid rgba(255,255,255,0.10)",
              background: "rgba(0,0,0,0.18)"
            }}>
              <div style={{ fontWeight: 900, marginBottom: 8 }}>Základ</div>

              <label style={{ display: "flex", gap: 10, alignItems: "center", userSelect: "none" }}>
                <input
                  type="checkbox"
                  checked={!!formData?.identita?.udajeDleDokladu}
                  onChange={(e) => setPath("identita.udajeDleDokladu", !!e.target.checked)}
                />
                <span style={{ fontWeight: 900 }}>Údaje dle dokladu (zamknout)</span>
              </label>
              <div style={{ fontSize: 12, opacity: 0.75, marginTop: 6 }}>
                OP ≠ realita → když odškrtneš, můžeš ručně upravit místo narození i bydliště.
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 12, marginTop: 12 }}>
                <div>
                  <div style={{ fontSize: 12, opacity: 0.75, marginBottom: 6 }}>Státní příslušnost</div>
                  <input
                    value={formData?.identita?.statniPrislusnost || ""}
                    onChange={(e) => setPath("identita.statniPrislusnost", e.target.value)}
                    placeholder='např. "ČR" / "SR" / "USA"'
                    style={{
                      width: "100%",
                      padding: "10px 12px",
                      borderRadius: 12,
                      border: "1px solid rgba(255,255,255,0.18)",
                      background: "rgba(255,255,255,0.06)",
                      color: "inherit",
                      outline: "none"
                    }}
                  />
                  <div style={{ fontSize: 12, opacity: 0.75, marginTop: 6 }}>
                    Neovlivňuje místo narození – to lze vyplnit vždy.
                  </div>
                </div>
              </div>
            </div>

            {/* Místo narození */}
            <div style={{
              padding: 12,
              borderRadius: 14,
              border: "1px solid rgba(255,255,255,0.10)",
              background: "rgba(0,0,0,0.18)"
            }}>
              <div style={{ fontWeight: 900, marginBottom: 8 }}>Místo narození</div>

              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 12 }}>
                <div>
                  <div style={{ fontSize: 12, opacity: 0.75, marginBottom: 6 }}>Obec</div>
                  <input
                    value={formData?.identita?.mistoNarozeni?.obec || ""}
                    onChange={(e) => setPath("identita.mistoNarozeni.obec", e.target.value)}
                    placeholder="např. Bratislava"
                    disabled={!!formData?.identita?.udajeDleDokladu}
                    style={{
                      width: "100%",
                      padding: "10px 12px",
                      borderRadius: 12,
                      border: "1px solid rgba(255,255,255,0.18)",
                      background: "rgba(255,255,255,0.06)",
                      color: "inherit",
                      outline: "none",
                      opacity: !!formData?.identita?.udajeDleDokladu ? 0.6 : 1
                    }}
                  />
                </div>

                <div>
                  <div style={{ fontSize: 12, opacity: 0.75, marginBottom: 6 }}>Část obce (volitelné)</div>
                  <input
                    value={formData?.identita?.mistoNarozeni?.cast || ""}
                    onChange={(e) => setPath("identita.mistoNarozeni.cast", e.target.value)}
                    placeholder="např. Ružinov"
                    disabled={!!formData?.identita?.udajeDleDokladu}
                    style={{
                      width: "100%",
                      padding: "10px 12px",
                      borderRadius: 12,
                      border: "1px solid rgba(255,255,255,0.18)",
                      background: "rgba(255,255,255,0.06)",
                      color: "inherit",
                      outline: "none",
                      opacity: !!formData?.identita?.udajeDleDokladu ? 0.6 : 1
                    }}
                  />
                </div>

                <div>
                  <div style={{ fontSize: 12, opacity: 0.75, marginBottom: 6 }}>Okres (volitelné)</div>
                  <input
                    value={formData?.identita?.mistoNarozeni?.okres || ""}
                    onChange={(e) => setPath("identita.mistoNarozeni.okres", e.target.value)}
                    placeholder="např. Praha-západ"
                    disabled={!!formData?.identita?.udajeDleDokladu}
                    style={{
                      width: "100%",
                      padding: "10px 12px",
                      borderRadius: 12,
                      border: "1px solid rgba(255,255,255,0.18)",
                      background: "rgba(255,255,255,0.06)",
                      color: "inherit",
                      outline: "none",
                      opacity: !!formData?.identita?.udajeDleDokladu ? 0.6 : 1
                    }}
                  />
                </div>

                <div>
                  <div style={{ fontSize: 12, opacity: 0.75, marginBottom: 6 }}>Stát narození</div>
                  <input
                    value={formData?.identita?.mistoNarozeni?.stat || ""}
                    onChange={(e) => setPath("identita.mistoNarozeni.stat", e.target.value)}
                    placeholder='např. "ČR" / "SR" / "USA"'
                    disabled={!!formData?.identita?.udajeDleDokladu}
                    style={{
                      width: "100%",
                      padding: "10px 12px",
                      borderRadius: 12,
                      border: "1px solid rgba(255,255,255,0.18)",
                      background: "rgba(255,255,255,0.06)",
                      color: "inherit",
                      outline: "none",
                      opacity: !!formData?.identita?.udajeDleDokladu ? 0.6 : 1
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Doklad */}
            <div style={{
              padding: 12,
              borderRadius: 14,
              border: "1px solid rgba(255,255,255,0.10)",
              background: "rgba(0,0,0,0.18)"
            }}>
              <div style={{ fontWeight: 900, marginBottom: 8 }}>Doklad</div>

              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 12 }}>
                <div>
                  <div style={{ fontSize: 12, opacity: 0.75, marginBottom: 6 }}>Typ dokladu</div>
                  <select
                    value={formData?.identita?.doklad?.typ || "OP"}
                    onChange={(e) => setPath("identita.doklad.typ", e.target.value)}
                    style={{
                      width: "100%",
                      padding: "10px 12px",
                      borderRadius: 12,
                      border: "1px solid rgba(255,255,255,0.18)",
                      background: "rgba(255,255,255,0.06)",
                      color: "inherit",
                      outline: "none"
                    }}
                  >
                    <option value="OP">OP</option>
                    <option value="PAS">PAS</option>
                    <option value="RP">ŘP</option>
                    <option value="JINY">Jiný</option>
                  </select>
                </div>

                <div>
                  <div style={{ fontSize: 12, opacity: 0.75, marginBottom: 6 }}>Číslo dokladu</div>
                  <input
                    value={formData?.identita?.doklad?.cislo || ""}
                    onChange={(e) => setPath("identita.doklad.cislo", e.target.value)}
                    placeholder="např. 123456789 / AB123456"
                    style={{
                      width: "100%",
                      padding: "10px 12px",
                      borderRadius: 12,
                      border: "1px solid rgba(255,255,255,0.18)",
                      background: "rgba(255,255,255,0.06)",
                      color: "inherit",
                      outline: "none"
                    }}
                  />
                </div>
              </div>

              <div style={{ marginTop: 12, fontSize: 12, opacity: 0.75 }}>
                Soubory (OP/PAS/ŘP) necháme napojené na tvůj stávající uploader v této záložce — tady zatím jen přehled.
              </div>
            </div>

            {/* Poznámka */}
            <div style={{
              padding: 12,
              borderRadius: 14,
              border: "1px solid rgba(255,255,255,0.10)",
              background: "rgba(0,0,0,0.18)"
            }}>
              <div style={{ fontWeight: 900, marginBottom: 8 }}>Poznámka k identitě (volitelné)</div>
              <textarea
                value={formData?.identita?.poznamka || ""}
                onChange={(e) => setPath("identita.poznamka", e.target.value)}
                placeholder='např. "občan ČR, narozen SR" / "doklad propadlý" / "bez rodného čísla"...'
                style={{
                  width: "100%",
                  minHeight: 80,
                  padding: "10px 12px",
                  borderRadius: 12,
                  border: "1px solid rgba(255,255,255,0.18)",
                  background: "rgba(255,255,255,0.06)",
                  color: "inherit",
                  outline: "none"
                }}
              />
            </div>
          </div>
        </div>
      </details>


<div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 12, flexWrap: "wrap" }}>
        <button
          onClick={handleSaveToKniha}
          disabled={saving}
          style={{
            padding: "10px 14px",
            borderRadius: 10,
            border: "1px solid #444",
            cursor: saving ? "not-allowed" : "pointer",
            fontWeight: 900,
            background: "#111",
          }}
        >
          {saving ? "Ukládám..." : (currentOrderId ? "Uložit změny do knihy" : "Založit zakázku do knihy")}
        </button>

        {currentOrderId ? (
          <div style={{ fontWeight: 900, opacity: 0.9 }}>ID zakázky: {currentOrderId}</div>
        ) : (
          <div style={{ fontWeight: 800, opacity: 0.7 }}>Ještě není založeno v knize</div>
        )}

        {saveMsg ? <div style={{ fontWeight: 900 }}>{saveMsg}</div> : null}
        {saveErr ? <div style={{ fontWeight: 900 }}>{saveErr}</div> : null}
      </div>
<div style={{ border: "1px solid #333", borderRadius: 12, padding: 12, marginBottom: 12 }}>
        <div style={{ fontWeight: 900, marginBottom: 10 }}>🪪 Identita (OP)</div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <div>
            <div style={labelStyle}>Jméno zesnulého</div>
            <input style={inputStyle} name="jmenoZesnuleho" value={v.jmenoZesnuleho || ""} onChange={onChange} />
          </div>

          <div>
            <div style={labelStyle}>Příjmení zesnulého</div>
            <input style={inputStyle} name="prijmeniZesnuleho" value={v.prijmeniZesnuleho || ""} onChange={onChange} />
          </div>

          <div>
            <div style={labelStyle}>Datum narození</div>
            <input style={inputStyle} type="date" name="datumNarozeniZesnuleho" value={v.datumNarozeniZesnuleho || ""} onChange={onChange} />
          </div>

          <div>
            <div style={labelStyle}>Rodné číslo</div>
            <input style={inputStyle} name="rodneCislo" value={v.rodneCislo || ""} onChange={onChange} />
          </div>

          <div style={{ gridColumn: "1 / -1" }}>
            <div style={labelStyle}>Trvalé bydliště</div>
            <input style={inputStyle} name="trvaleBydliste" value={v.trvaleBydliste || ""} onChange={onChange} placeholder="Ulice, č.p., město, PSČ" />
          </div>
        </div>
      </div>

      <div style={{ border: "1px solid #333", borderRadius: 12, padding: 12 }}>
        <div style={{ fontWeight: 900, marginBottom: 10 }}>🩺 Úmrtí + Ohledací list</div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
          <div>
            <div style={labelStyle}>Datum úmrtí</div>
            <input style={inputStyle} type="date" name="datumUmrti" value={v.datumUmrti || ""} onChange={onChange} />
          </div>

          <div>
            <div style={labelStyle}>Čas úmrtí</div>
            <input style={inputStyle} type="time" name="casUmrti" value={v.casUmrti || ""} onChange={onChange} />
          </div>

          <div>
            <div style={labelStyle}>Místo úmrtí</div>
            <input style={inputStyle} name="mistoUmrti" value={v.mistoUmrti || ""} onChange={onChange} />
          </div>

          <div style={{ gridColumn: "1 / -1" }}>
            <div style={labelStyle}>Adresa úmrtí</div>
            <input style={inputStyle} name="adresaUmrti" value={v.adresaUmrti || ""} onChange={onChange} />
          </div>

          <div>
            <div style={labelStyle}>Datum prohlídky</div>
            <input style={inputStyle} type="date" name="datumProhlidky" value={v.datumProhlidky || ""} onChange={onChange} />
          </div>

          <div>
            <div style={labelStyle}>Čas prohlídky</div>
            <input style={inputStyle} type="time" name="casProhlidky" value={v.casProhlidky || ""} onChange={onChange} />
          </div>

          <div>

            {/* PITVA_SELECT_UI (moved to UMRTI section) */}
            <div style={{ marginTop: 8 }}>
              <div className="vi-label">Pitva (typ)</div>
              <select
                className="vi-select"
                value={(formData?.vstupni?.pitvaTyp || formData?.pitvaTyp || "zdravotni")}
                onChange={(e) => {
                  const pitvaTyp = String(e.target.value || "zdravotni");
                  try { setPath?.("vstupni.pitvaTyp", pitvaTyp); } catch (e) {}
                  try { setPath?.("pitvaTyp", pitvaTyp); } catch (e) {}
                  try {
                    mergeFormData?.({
                      pitvaTyp,
                      vstupni: { ...(formData?.vstupni || {}), pitvaTyp },
                    });
                  } catch (e) {}
                }}
              >
                <option value="zdravotni">Zdravotní pitva</option>
                <option value="soudni">Soudní pitva</option>
                <option value="bez">Bez pitvy</option>
              </select>

              <div style={{ fontSize: 12, opacity: 0.8, marginTop: 6 }}>
                Aktuálně: <b>{(formData?.vstupni?.pitvaTyp || formData?.pitvaTyp || "zdravotni")}</b>
              </div>
            </div>
            {/* /PITVA_SELECT_UI */}


            <div style={labelStyle}>Pitva / pitevna</div>
            <input style={inputStyle} name="pitevna" value={v.pitevna || ""} onChange={onChange} placeholder="ano/ne, kde" />
          </div>

          <div>
            <div style={labelStyle}>Lékař (jméno)</div>
            <input style={inputStyle} name="lekarJmeno" value={v.lekarJmeno || ""} onChange={onChange} />
          </div>

          <div>
            <div style={labelStyle}>Lékař (telefon)</div>
            <input style={inputStyle} name="lekarTelefon" value={v.lekarTelefon || ""} onChange={onChange} />
          </div>

          <div>
            <div style={labelStyle}>Diagnóza</div>
            <input style={inputStyle} name="diagnoza" value={v.diagnoza || ""} onChange={onChange} />
          </div>

          <div>
            <div style={labelStyle}>Infekce / riziko</div>
            <input style={inputStyle} name="infekce" value={v.infekce || ""} onChange={onChange} placeholder="např. MRSA / TBC / —" />
          </div>

          <div style={{ gridColumn: "1 / -1" }}>
            <div style={labelStyle}>Poznámka</div>
            <input style={inputStyle} name="poznamka" value={v.poznamka || ""} onChange={onChange} />
          </div>
        </div>
      </div>
    </div>
  
</div>
  </>
);
}
